import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/prototype/allocation-planning/$")({
  beforeLoad: ({ location }) => {
    throw redirect({
      href: location.href.replace("/prototype/allocation-planning", "/allocation"),
      replace: true,
    })
  },
})
